import type { Editor } from '@tiptap/react';
import type { IconType } from 'react-icons';

import {
  FiArrowDown,
  FiArrowLeft,
  FiArrowRight,
  FiArrowUp,
  FiTrash2,
} from 'react-icons/fi';

export interface MarkdownTableCommand {
  id: string;
  label: string;
  icon: IconType;
  run: () => void;
  canRun: () => boolean;
}

export function isMarkdownTableActive(editor: Editor): boolean {
  return (
    editor.isActive('table') ||
    editor.isActive('tableCell') ||
    editor.isActive('tableHeader')
  );
}

export function createMarkdownTableCommands(
  editor: Editor,
): MarkdownTableCommand[] {
  const chain = () => editor.chain().focus();

  return [
    {
      id: 'add-row-above',
      label: 'Add row above',
      icon: FiArrowUp,
      canRun: () => editor.can().addRowBefore(),
      run: () => chain().addRowBefore().run(),
    },
    {
      id: 'add-row-below',
      label: 'Add row below',
      icon: FiArrowDown,
      canRun: () => editor.can().addRowAfter(),
      run: () => chain().addRowAfter().run(),
    },
    {
      id: 'add-column-left',
      label: 'Add column left',
      icon: FiArrowLeft,
      canRun: () => editor.can().addColumnBefore(),
      run: () => chain().addColumnBefore().run(),
    },
    {
      id: 'add-column-right',
      label: 'Add column right',
      icon: FiArrowRight,
      canRun: () => editor.can().addColumnAfter(),
      run: () => chain().addColumnAfter().run(),
    },
    {
      id: 'delete-row',
      label: 'Delete row',
      icon: FiTrash2,
      canRun: () => editor.can().deleteRow(),
      run: () => chain().deleteRow().run(),
    },
    {
      id: 'delete-column',
      label: 'Delete column',
      icon: FiTrash2,
      canRun: () => editor.can().deleteColumn(),
      run: () => chain().deleteColumn().run(),
    },
    {
      id: 'delete-table',
      label: 'Delete table',
      icon: FiTrash2,
      canRun: () => editor.can().deleteTable(),
      run: () => chain().deleteTable().run(),
    },
  ];
}
